// Initialize carousel and disable nav buttons when needed
(function() {
  function initializeCarousel() {
    const carousels = document.querySelectorAll('.products.carousel');
    
    carousels.forEach(carousel => {
      const wrapper = carousel.closest('.custom-featured-collection__inner');
      if (!wrapper) return;
      
      const prevBtn = wrapper.querySelector('.flickity-prev');
      const nextBtn = wrapper.querySelector('.flickity-next');
      
      if (!prevBtn || !nextBtn) return;
      
      // Get Flickity instance
      let flkty = carousel.flickityInstance || (window.Flickity && Flickity.data(carousel));
      
      if (!flkty) return;
      
      // Update button states
      function updateNavButtonStates() {
        if (!flkty) return;
        
        const totalSlides = flkty.slides.length;
        const currentIndex = flkty.selectedIndex;
        const isAtStart = currentIndex === 0;
        
        // Check if we're at the end by comparing the position of the last cell
        // The carousel is at the end when the last cell's right edge is at or before the viewport right edge
        let isAtEnd = false;
        
        if (flkty.cells && flkty.cells.length > 0) {
          const lastCell = flkty.cells[flkty.cells.length - 1];
          const carouselSize = flkty.size.innerWidth;
          const lastCellPosition = lastCell.target;
          const lastCellSize = lastCell.size.outerWidth;
          
          // We're at the end if the last cell's right edge is visible
          isAtEnd = Math.abs(flkty.x) + carouselSize >= lastCellPosition + lastCellSize - 1;
        }
        
        // Update prev button
        if (isAtStart) {
          prevBtn.setAttribute('disabled', 'disabled');
          prevBtn.style.opacity = '0.3';
          prevBtn.style.pointerEvents = 'none';
          prevBtn.style.cursor = 'not-allowed';
        } else {
          prevBtn.removeAttribute('disabled');
          prevBtn.style.opacity = '1';
          prevBtn.style.pointerEvents = 'all';
          prevBtn.style.cursor = 'pointer';
        }
        
        // Update next button
        if (isAtEnd) {
          nextBtn.setAttribute('disabled', 'disabled');
          nextBtn.style.opacity = '0.3';
          nextBtn.style.pointerEvents = 'none';
          nextBtn.style.cursor = 'not-allowed';
        } else {
          nextBtn.removeAttribute('disabled');
          nextBtn.style.opacity = '1';
          nextBtn.style.pointerEvents = 'all';
          nextBtn.style.cursor = 'pointer';
        }
      }
      
      // Initial state
      updateNavButtonStates();
      
      // Listen to Flickity events with all possible event types
      carousel.addEventListener('change.flickity', updateNavButtonStates);
      carousel.addEventListener('select.flickity', updateNavButtonStates);
      carousel.addEventListener('settle.flickity', updateNavButtonStates);
      carousel.addEventListener('staticClick.flickity', updateNavButtonStates);
      carousel.addEventListener('dragEnd.flickity', updateNavButtonStates);
      
      // Also add click listeners to buttons to update immediately
      prevBtn.addEventListener('click', function() {
        setTimeout(updateNavButtonStates, 10);
        setTimeout(updateNavButtonStates, 50);
        setTimeout(updateNavButtonStates, 150);
      });
      
      nextBtn.addEventListener('click', function() {
        setTimeout(updateNavButtonStates, 10);
        setTimeout(updateNavButtonStates, 50);
        setTimeout(updateNavButtonStates, 150);
      });
      
      // Direct method bindings - try multiple event names
      if (flkty) {
        flkty.on('change', updateNavButtonStates);
        flkty.on('select', updateNavButtonStates);
        flkty.on('settle', updateNavButtonStates);
        flkty.on('staticClick', updateNavButtonStates);
        flkty.on('dragEnd', updateNavButtonStates);
      }
      
      // Add a MutationObserver as fallback to monitor class changes
      const observer = new MutationObserver(updateNavButtonStates);
      observer.observe(carousel, { attributes: true, attributeFilter: ['data-flickity-index'] });
    });
  }
  
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initializeCarousel, 100);
    });
  } else {
    setTimeout(initializeCarousel, 100);
  }
  
  // Re-initialize when Shopify loads a section
  window.addEventListener('shopify:section:load', initializeCarousel);
})();
